import { createRouter as createVueRouter, createWebHistory } from 'vue-router';
import { authGuard } from '@auth0/auth0-vue';
import AdminHome from '@admin/pages/index.vue';
import AdminUsers from '@admin/pages/users/index.vue';
import AdminContractLicense from '@admin/pages/serviceId/licenses/index.vue';
import AdminContact from '@admin/pages/other/contact/index.vue';
import AdminGroups from '@admin/pages/groups/index.vue';
import AdminGroupManagement from '@admin/pages/groups/groupId/index.vue';
import NotFound from '@admin/pages/common/error/index.vue';
import ServerError from '@admin/pages/common/error/serverError/index.vue';
import Unauthorized from '@admin/pages/common/error/unauthorized/index.vue';
import { getUserRole } from '@spectee/ts/getOrganization';

export function createRouter() {
  const routes = [
    {
      path: '',
      name: 'AdminHome',
      component: AdminHome,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/users/',
      name: 'AdminUsers',
      component: AdminUsers,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/license/:planMasterId/:licenseId/',
      name: 'AdminContractLicense',
      component: AdminContractLicense,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/groups/',
      name: 'AdminGroups',
      component: AdminGroups,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/groups/groupManagement',
      name: 'AdminGroupManagement',
      component: AdminGroupManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/other/contact/',
      name: 'AdminContact',
      component: AdminContact,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/unauthorized',
      name: 'UnauthorizedComponent',
      component: Unauthorized,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/:catchAll(.*)/',
      name: 'NotFound',
      component: NotFound,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/error/',
      name: 'ServerError',
      component: ServerError,
      meta: {
        requiresAuth: false,
      },
    },
  ];

  const router = createVueRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
  });

  router.beforeEach(authGuard);

  router.beforeEach((to, _from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth);

    const isContractAdministrator = getUserRole()?.some(
      role => role.id === import.meta.env.VITE_APP_CONTRACT_ADMIN_LICENSE_ID
    );

    if (requiresAuth && !isContractAdministrator) {
      next({ name: 'UnauthorizedComponent' });
    } else if (to.path === '/unauthorized' && isContractAdministrator) {
      next({ name: 'AdminHome' });
    } else {
      next();
    }
  });

  return router;
}
